import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import config from 'config/config';
import checkOrSetSlash from 'utils/checkOrSetSlash';
import { prepareFCHeader } from 'utils/request';

const rootProjectPath = `${checkOrSetSlash(
  config.apiHostGatewayGlobal,
  'apiHostGatewayGlobal',
)}api/organizations`;

export const workspacesApi = createApi({
  reducerPath: 'workspacesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: rootProjectPath,
    prepareHeaders: prepareFCHeader(),
  }),
  tagTypes: ['Workspaces'],
  endpoints: builder => ({
    fetchWorkspaces: builder.query({
      query: ({ organizationId, search_term, parent_id }) => ({
        url: `${organizationId}/workspaces/user_workspaces`,
        method: 'POST',
        body: {
          parent_id,
          search_term,
        },
      }),
      providesTags: ['Workspaces'],
      keepUnusedDataFor: 0,
      serializeQueryArgs: ({ queryArgs }) => {
        const { organizationId, parent_id } = queryArgs;
        return `${organizationId}-${parent_id || 'root'}`;
      },
      transformResponse: response => ({
        workspaces: response.workspaces.map(workspace => ({
          ...workspace,
          path: workspace.parent_id ? [workspace.parent_id, workspace.id] : [workspace.id],
        })),
        total: response.count,
      }),
      merge: (currentCache, newItems, { arg }) => {
        const { parent_id } = arg;
        if (!parent_id) {
          return newItems;
        }
        return {
          ...currentCache,
          workspaces: [...(currentCache?.workspaces || []), ...(newItems?.workspaces || [])],
          total: (currentCache?.total || 0) + (newItems?.total || 0),
        };
      },
    }),
    deleteWorkSpace: builder.mutation({
      query: ({ organizationId, workspaceId }) => ({
        url: `${organizationId}/workspaces/${workspaceId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Workspaces'],
    }),
  }),
});

export const { useLazyFetchWorkspacesQuery, useDeleteWorkSpaceMutation } = workspacesApi;
